module.exports = __webpack_public_path__ + "static/iberpay-logo-e67c1f7251c3572fd46d49f8a4c18a98.jpg";